module.exports = __webpack_public_path__ + "img/C03TechGiftofSequana_ua.46d2d460.webp";